import Layout from "../layouts/layout";
import DefineVisitors from "../sections/_mainAttractionDetail/DefineVisitors";
import Details from "../sections/_mainAttractionDetail/Details";
import Schedule from "../sections/_mainAttractionDetail/Schedule";
import VisitorsCount from "../sections/_mainAttractionDetail/VisitorsCount";
import styles from "../styles/_screens/mainAttractionDetail.module.scss";

const MainAttractionDetail = () => {
  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.wrapper}>
          <h1>Main attraction in the barracks complex</h1>

          <Details />
          <Schedule />
          <VisitorsCount />
          <DefineVisitors />
        </div>
      </div>
    </Layout>
  );
};

export default MainAttractionDetail;
